<formly-form [fields]="fields" [options]="options" [model]="model" [form]="form"></formly-form>
<button mat-flat-button color="primary" (click)="onSubmit()">Submit</button>
